import state from './state';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';

const mcp = {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};

export default mcp;
